import type { ChangeEvent } from 'react';
import { Box } from '@chakra-ui/react';
import { useWallets } from 'hooks';
import { useTranslation } from 'localization';

import { Input } from 'components';

// eslint-disable-next-line no-unused-vars
type WalletSelectionTypes = { setWalletId: (id: string) => void };

const WalletSelection: React.FC<WalletSelectionTypes> = ({
  setWalletId,
}: WalletSelectionTypes) => {
  const { t } = useTranslation('component.withdraw.ld');

  const { data: wallets } = useWallets({
    queries: {
      type: 'CRYPTO',
    },
  });

  const walletList =
    wallets?.list
      ?.filter((wallet) => wallet.currency.symbol === 'USDT')
      .map((wallet) => ({
        label: wallet.currency.title,
        value: wallet.id,
        currency_id: wallet.currency.id,
      })) || [];

  return (
    <Box w={{ base: '100%', md: '50%' }}>
      <Input
        name={t('form.destination_wallet')}
        placeholder={t('form.destination_wallet')}
        label={t('form.destination_wallet')}
        isSelectBox
        options={walletList}
        onChange={(v: ChangeEvent<HTMLSelectElement>) => {
          if (v.target.value) {
            setWalletId(
              walletList.find((wallet) => wallet.value === v.target.value)
                ?.value as string
            );
          } else {
            setWalletId('');
          }
        }}
      />
    </Box>
  );
};
export default WalletSelection;
